import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react-refresh/only-export-components -- library showcase exports both the component and the case data */
import { SceneSchema, allowedTextPositions, defaultBookAttributes, } from '@kitup/book-schema';
import React, {} from 'react';
import { renderSpread } from './spread-templates.js';
import { bookFontStack } from './font-stack.js';
const SHOWCASE_IMAGE_URL = 'data:image/svg+xml;charset=utf-8,' +
    encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="1200" height="850" viewBox="0 0 1200 850">
      <defs><linearGradient id="sky" x2="1" y2="1"><stop stop-color="#9dd7e8"/><stop offset="1" stop-color="#f6c8a8"/></linearGradient></defs>
      <rect width="1200" height="850" fill="url(#sky)"/>
      <circle cx="960" cy="145" r="78" fill="#fff1a6" opacity=".9"/>
      <path d="M0 690 Q220 540 430 690 T850 665 T1200 690 V850 H0Z" fill="#779d70"/>
      <path d="M500 640 q100-270 200 0" fill="#6f5578" opacity=".55"/>
      <circle cx="600" cy="380" r="88" fill="#f7e2cb"/>
      <path d="M520 350 q80-130 160 0" fill="#624a3d"/>
    </svg>
  `);
const TEXT = 'Мира открыла старую карту.\nЗа холмами сияла добрая звезда.\nТак началось новое приключение.';
function opposite(position) {
    const pairs = {
        'top-left': 'bottom-right',
        'top-right': 'bottom-left',
        'bottom-left': 'top-right',
        'bottom-right': 'top-left',
    };
    return pairs[position] ?? position;
}
function block(index, position) {
    return {
        slotId: `slot-${index}`,
        text: TEXT,
        position,
        manual: true,
    };
}
function sceneFor(layoutId, position, bandImageRatio) {
    const textBlocks = layoutId === 'full-bleed'
        ? [block(0, position), block(1, opposite(position))]
        : [block(0, position)];
    const parsed = SceneSchema.parse({
        id: `showcase-${layoutId}-${position}`,
        bookId: 'showcase',
        index: 0,
        kind: 'spread',
        layoutId,
        textRu: textBlocks.map((item) => item.text).join(' '),
        textBlocks,
        bandImageRatio,
    });
    return { ...parsed, imageUrl: SHOWCASE_IMAGE_URL, imageAlt: 'Иллюстрация-витрина' };
}
/** All valid positions; band also covers the edge ratios 0.5/0.85. */
export function showcaseCases() {
    return ['split', 'full-bleed', 'band'].flatMap((layoutId) => allowedTextPositions(layoutId).map((position, index) => {
        const bandImageRatio = layoutId === 'band' ? (index === 0 ? 0.5 : 0.85) : null;
        const ratioLabel = bandImageRatio === null ? '' : ` · ratio ${bandImageRatio}`;
        return {
            key: `${layoutId}:${position}`,
            label: `${layoutId} · ${position}${ratioLabel}`,
            scene: sceneFor(layoutId, position, bandImageRatio),
        };
    }));
}
/**
 * Layout showcase. The shared package does not know the brand and must not: the name
 * comes from above, and without it the showcase signs itself.
 */
export function RenderShowcase({ title = 'book-render' } = {}) {
    const attributes = defaultBookAttributes();
    return (_jsxs("main", { "data-render-showcase": "", style: {
            minHeight: '100vh',
            padding: '24px',
            background: '#f2eee8',
            color: '#332b3b',
            fontFamily: bookFontStack(),
        }, children: [_jsx("h1", { style: { margin: '0 0 8px', fontSize: '24px' }, children: title }), _jsx("p", { style: { margin: '0 0 24px', color: '#665c6d' }, children: "\u0422\u0440\u0438 \u0440\u0430\u0441\u043A\u043B\u0430\u0434\u043A\u0438, \u0432\u0441\u0435 \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435 \u043F\u043E\u0437\u0438\u0446\u0438\u0438 \u0442\u0435\u043A\u0441\u0442\u0430, \u0435\u0434\u0438\u043D\u0430\u044F \u0433\u0435\u043E\u043C\u0435\u0442\u0440\u0438\u044F book-schema." }), _jsx("div", { style: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(360px, 1fr))',
                    gap: '24px',
                    alignItems: 'start',
                }, children: showcaseCases().map((item) => (_jsxs("section", { "data-showcase-case": item.key, style: {
                        padding: '14px',
                        borderRadius: '14px',
                        background: '#fff',
                        boxShadow: '0 8px 28px rgba(57,39,73,.09)',
                    }, children: [_jsx("h2", { style: { margin: '0 0 12px', fontSize: '14px' }, children: item.label }), _jsx("div", { style: { zoom: 0.31 }, children: renderSpread(item.scene, attributes) })] }, item.key))) })] }));
}
//# sourceMappingURL=showcase.js.map